export function finitePercent(value) {
  if (value === null || value === undefined || typeof value === 'boolean' || String(value).trim() === '') return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

export function formatPercent(value) {
  const number = finitePercent(value)
  if (number === null) return '--'
  const rounded = Number(number.toFixed(2))
  return `${rounded >= 0 ? '+' : ''}${rounded.toFixed(2)}%`
}

export function performanceClass(value) {
  const number = finitePercent(value)
  return number === null || number === 0 ? 'performance-neutral' : number > 0 ? 'performance-up' : 'performance-down'
}

export function topicKlinePerformance(rows, reportDate) {
  const candle = rows ? rows.find(row => row.trade_date === reportDate) : null
  const result = { date: candle ? candle.trade_date : '', open: null, current: null }
  if (!candle) return result
  const previous = finitePercent(candle.prev_close)
  if (previous === null || previous <= 0) return result
  const open = finitePercent(candle.open)
  const close = finitePercent(candle.close)
  result.open = open !== null && open > 0 ? (open / previous - 1) * 100 : null
  result.current = close !== null && close > 0 ? (close / previous - 1) * 100 : null
  return result
}
